import { useAtom } from 'jotai'
import { type PropsWithChildren, useEffect } from 'react'

import { Flex } from '@/components/ui/flex'
import useColorModeValue from '@/hooks/useColorModeValue'
import NetworkError from '@/pages/NetworkError.tsx'
import { networkErrorAtom } from '@/store/app/NetworkErrorAtom.ts'

import Notifications from './notifications'

interface IProps {
    children?: React.ReactNode
}

const PageLayout: React.FC<PropsWithChildren<IProps>> = ({ children }) => {
    useEffect(() => {
        function adjustMainContentHeight() {
            const mainContent = document.querySelector('.main-content') as HTMLDivElement
            if (mainContent) {
                mainContent.style.height = `${window.innerHeight}px`
            }
        }

        adjustMainContentHeight()

        window.addEventListener('resize', adjustMainContentHeight)
        window.addEventListener('orientationchange', adjustMainContentHeight)

        return () => {
            window.removeEventListener('resize', adjustMainContentHeight)
            window.removeEventListener('orientationchange', adjustMainContentHeight)
        }
    }, [])

    const [networkError] = useAtom(networkErrorAtom)

    return (
        <Flex
            direction="column"
            className={'main-content ' + useColorModeValue('light', 'dark')}
            backgroundColor={useColorModeValue('surface.light', 'black')}
        >
            {networkError ? (
                <NetworkError />
            ) : (
                <>
                    {children}
                    <Notifications />
                </>
            )}
        </Flex>
    )
}

export default PageLayout
